import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import applicationSlice from './slices/applicationSlice';
import crewSlice from './slices/crewSlice';
import greenhouseSlice from './slices/greenhouseSlice';
import selectionSlice from './slices/selectionSlice';
import userSlice from './slices/userSlice';
import purchaseOrderSlice from './slices/purchaseOrderSlice';
import purchaseOrderDetailSlice from './slices/purchaseOrderDetailSlice';

const store = configureStore({
    reducer: {
        application: applicationSlice,
        user: userSlice,
        users: userSlice,
        crew: crewSlice,
        crews: crewSlice,
        greenhouses: greenhouseSlice,
        greenhouse: greenhouseSlice,
        purchaseOrder: purchaseOrderSlice,
        purchaseOrderDetails: purchaseOrderDetailSlice,
        selection: selectionSlice,
    },
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware({
            serializableCheck: false
        })
    
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store;